import { AccessGuids, ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths, ToastShowDelay } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BooleanService } from 'src/app/core/services/utelize/general/boolean-service';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { LicenceCompanyVisibleDTO } from 'src/app/core/models/system/licence/licence-company-visible.dto';
import { LicencesCompanyVisibleService } from 'src/app/core/services/utelize/system/licence/licences-company-visible-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { ToastService } from 'src/app/core/services/toast-service';

const apiPath             =environment.eSimApi+eSimApiPaths.LicencesCompanyVisible + "/" + eSimApiPaths.LicencesGetLicencesAndVisibilityMarkForCompany;
const exportFilenameSuffix="Licences-Company-Visible-Data";
const popUpTitle          ="User";

@Component({
  selector: 'app-licences-company-visible-embedded',
  templateUrl: './licences-company-visible.component.html',
  styleUrls: ['./licences-company-visible.component.scss'],
  providers: [GridViewService]
})

export class LicencesCompanyVisibleEmbeddedComponent implements AfterViewInit, OnChanges, OnInit {
  
  @Input() companyId: number | undefined;
  
  @Output() gridAddClick : EventEmitter<void>=new EventEmitter<void>();
  @Output() gridEditClick: EventEmitter<void>=new EventEmitter<void>();
  
  @ViewChild('gridView', { static: false }) gridView!: GridViewComponent;
                         
  get isLicencesAdminKeyHolder(): boolean { return this.componentAccessUserService.hasAccessGuid(AccessGuids.LicencesAdminKey, true); }

  get embeddedGridHeight() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.ModalGridHeightEmbedded, 420); }
  
  private gridViewDefaults!: GridViewDefaults;
  
  public curUser        : SystemUserDTO;
  public dgApiPath!     : DgApiPath | undefined;
  public dgActionColumn!: DgActionColumn | undefined;
  public dgColumns!     : Array<DgColumn>;
  public dgPopup!       : DgPopup | undefined;
  public dgProperties!  : DgProperties | undefined;
  public gotDgProperties: boolean=false;
  
  constructor(
    private authenticationService        : AuthenticationService,
    private booleanService               : BooleanService,
    private componentAccessUserService   : ComponentAccessUserService,
    private configSystemService          : ConfigSystemService,
    private encryptionService            : EncryptionService,
    private exceptionsService            : ExceptionsService,
    private licencesCompanyVisibleService: LicencesCompanyVisibleService,
    private toastService                 : ToastService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      if (this.companyId==undefined) {
        throw new Error("LicencesCompanyVisibleEmbeddedComponent - CompanyID cannot be determined");
      }

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setUpDgApiPathGet();

      await this.setUpDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathGet(): Promise<void> {
    try {
      const encResult     =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.companyId, true));
      const companyIdEncSS=encResult.result;

      this.dgApiPath!.get=apiPath + "?companyIdEncSS=" + companyIdEncSS;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting=false;
      this.dgActionColumn!.updateIcon   ="assets/images/_suresim/Button Toggle 55x23.png";
      this.dgActionColumn!.width        =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties               =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + this.companyId);
      this.dgProperties!.gridKey      ="EmbeddedLicencesCompanyVisible";
      this.dgProperties!.height       =this.embeddedGridHeight;
      this.dgProperties!.pageSize     =10;
      this.dgProperties!.showAddButton=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];
      
      //LicenceType
      dgColumn=this.gridViewDefaults.setUpDgColumn("licenceType", "Licence Type", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //LicenceName
      dgColumn=this.gridViewDefaults.setUpDgColumn("licenceName", "Licence", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);
      
      //CompanyHasLicence
      dgColumn            =this.gridViewDefaults.setUpDgColumn("companyHasLicence", "Allow", true, DgColumnDataType.boolean);
      dgColumn!.dataSource=this.booleanService.idAndDescriptionLookupDataSource();
      dgColumn!.width     =DgColumnWidths.active;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridToggleButtonClick(e: any) {
    try {
      if (e.row?.data?.companyHasLicence != undefined) {
        if (e.row?.data?.adminLocked && !this.isLicencesAdminKeyHolder) {
          this.toastService.show("Admin Locked Licences cannot be added or removed by you", { classname: 'bg-danger text-white', delay: ToastShowDelay.Danger });
          
          return;
        }

        e.row.data.companyHasLicence ? this.unSetLicencesCompanyVisible(e.row?.data?.licenceCompanyVisibleID)
                                     : this.setLicencesCompanyVisible(e.row?.data?.id);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public setLicencesCompanyVisible(licenceSystemId: number | undefined) {
    try {
      if (Number.isNaN(licenceSystemId))
        throw new Error("LicencesCompanyVisibleEmbeddedComponent - licenceSystemId cannot be determined");
      
      const licenceCompanyVisible: LicenceCompanyVisibleDTO={
        active         : true,
        companyID      : Number(this.companyId),
        enteredBy      : this.curUser.userId,
        id             : -1,
        licenceSystemID: Number(licenceSystemId)
      };
      
      this.licencesCompanyVisibleService.save(licenceCompanyVisible)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.gridView.refreshData();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public unSetLicencesCompanyVisible(licenceCompanyVisibleId: number | undefined) {
    try {
      if (Number.isNaN(licenceCompanyVisibleId))
        throw new Error("LicencesCompanyVisibleEmbeddedComponent - licenceCompanyVisibleId cannot be determined");

      this.licencesCompanyVisibleService.delete(Number(licenceCompanyVisibleId))
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.gridView.refreshData();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
